export const formatExportRecipientName = (name = '') => {
  const [firstName, ...lastNames] = name.split(' ');

  if (lastNames.length > 0) {
    const upperCaseNames = lastNames
      .map((lastName) => lastName.toUpperCase())
      .join(' ');
    return `${firstName} ${upperCaseNames}`;
  }

  return firstName;
};
